<template>
    <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-card class="elevation-12" color="tertiary">
                    <v-toolbar color="secondary" dark flat>
                        <v-toolbar-title>{{
                            $t('resetPasswordView.title')
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text class="pb-0">
                        <v-form class="mb-3" @submit.prevent="onReset">
                            <v-text-field
                                id="password"
                                v-model="formData.password"
                                :label="$t('resetPasswordView.password')"
                                prepend-icon="mdi-form-textbox-password"
                                type="password"
                                color="secondary"
                                error-count="2"
                                required
                                :error-messages="passwordErrors"
                                :disabled="isTokenErrorVisible"
                                @input="
                                    clearServerErrors('password');
                                    $v.formData.password.$touch();
                                "
                                @blur="$v.formData.password.$touch()"
                            />
                            <v-text-field
                                id="password-repeat"
                                v-model="formData.passwordRepeat"
                                :label="$t('resetPasswordView.passwordRepeat')"
                                prepend-icon="mdi-form-textbox-password"
                                type="password"
                                color="secondary"
                                error-count="2"
                                required
                                :error-messages="passwordRepeatErrors"
                                :disabled="isTokenErrorVisible"
                                @input="
                                    clearServerErrors('passwordRepeat');
                                    $v.formData.passwordRepeat.$touch();
                                "
                                @blur="$v.formData.passwordRepeat.$touch()"
                            />
                        </v-form>
                        <p class="red--text" v-if="isTokenErrorVisible">
                            <span class="text-h6">{{
                                $t('resetPasswordView.tokenErrorTitle')
                            }}</span>
                            <br />
                            {{ $t('resetPasswordView.tokenErrorMessage') }}
                        </p>
                    </v-card-text>
                    <v-card-actions class="pa-4">
                        <v-spacer />
                        <v-btn
                            class="elevation-0"
                            large
                            color="secondary"
                            @click="onReset"
                            :disabled="!isValid || isTokenErrorVisible"
                            >{{ $t('resetPasswordView.resetButton') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import resetPasswordValidatorMixin from '@/validators/auth/resetPasswordValidator.mixin';

export default {
    name: 'resetPasswordView',
    mixins: [resetPasswordValidatorMixin],
    data() {
        return {
            formData: {
                password: '',
                passwordRepeat: ''
            },
            isTokenErrorVisible: false
        };
    },
    async created() {
        try {
            await this.checkPasswordReset(this.$route.params.token);
        } catch (err) {
            this.isTokenErrorVisible = true;

            console.error(err);
        }
    },
    methods: {
        ...mapActions({
            checkPasswordReset: 'auth/checkPasswordReset',
            resetPassword: 'auth/resetPassword'
        }),

        async onReset() {
            try {
                this.$v.$touch();

                if (!this.isValid) {
                    return;
                }

                await this.resetPassword({
                    passwords: this.formData,
                    token: this.$route.params.token
                });

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('resetPasswordView.sentTitle'),
                    text: this.$t('resetPasswordView.sentMessage')
                });

                this.$router.push({ name: 'home' });
            } catch (error) {
                if (this.checkForServerFormErrors(error)) {
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t('resetPasswordView.title'),
                        text: this.$t('resetPasswordView.checkFormErrors')
                    });
                }
            }
        }
    }
};
</script>
